import { useEffect } from 'react'

interface SEOProps {
  title?: string
  description?: string
  keywords?: string
  ogImage?: string
  ogUrl?: string
  canonical?: string
}

export function SEO({
  title = "StayApp - Book Your Stay, Your Way | Multi-Service Booking Platform",
  description = "Book accommodation, safari adventures, restaurants, nightlife, beauty services, and car hire with negotiable pricing. All your travel and lifestyle needs in one app.",
  keywords = "accommodation booking, safari trips, restaurant reservations, nightlife booking, beauty services, car hire, negotiable pricing, travel booking app, lifestyle services, hotel booking, wellness booking",
  ogImage = "/logo.png",
  ogUrl,
  canonical,
}: SEOProps) {
  useEffect(() => {
    // Update document title
    document.title = title

    // Update or create meta tags
    const updateMetaTag = (name: string, content: string, attribute: string = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`)
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute(attribute, name)
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    }

    // Update description
    updateMetaTag('description', description)

    // Update keywords
    updateMetaTag('keywords', keywords)

    // Update Open Graph tags
    updateMetaTag('og:title', title, 'property')
    updateMetaTag('og:description', description, 'property')
    if (ogImage) {
      // Convert relative URLs to absolute
      const absoluteImage = ogImage.startsWith('http') ? ogImage : `https://stayapp.com${ogImage}`
      updateMetaTag('og:image', absoluteImage, 'property')
    }
    if (ogUrl) {
      updateMetaTag('og:url', ogUrl, 'property')
    }

    // Update Twitter tags
    updateMetaTag('twitter:title', title)
    updateMetaTag('twitter:description', description)
    if (ogImage) {
      // Convert relative URLs to absolute
      const absoluteImage = ogImage.startsWith('http') ? ogImage : `https://stayapp.com${ogImage}`
      updateMetaTag('twitter:image', absoluteImage)
    }

    // Update canonical URL
    if (canonical) {
      let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement
      if (!canonicalLink) {
        canonicalLink = document.createElement('link')
        canonicalLink.setAttribute('rel', 'canonical')
        document.head.appendChild(canonicalLink)
      }
      canonicalLink.setAttribute('href', canonical)
    }
  }, [title, description, keywords, ogImage, ogUrl, canonical])

  return null
}

